// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512051504/js/" + chunkId + "." + {"44":"b124eaa0","225":"eaf18297","481":"6aa2d882","486":"58ce0875","770":"ff781276"}[chunkId] + ".0.9612699948176788.chunk.js";
};